import { supabase } from "./api";

export const revalidate = 0;

export async function getAllData() {
  const { data, error } = await supabase.from("classdetailview").select()
  .order('studentName', { ascending: true });

  if (error) {
    throw new Error("Failed to fetch data");
  }
  return data;
}

export async function getDataWithClass(classId, instructorId) {
  //console.log("classId",classId,instructorId);
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    .eq("classId", classId)
    .or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
    .order('studentName', { ascending: true });
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getDataWithClassforInstructor(classId, instructorId) {
  //console.log("classId",classId,instructorId);
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    .eq("classId", classId)
    .eq("studentisActive", true)
    .or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
    .order('studentName', { ascending: true });
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}


export async function getDataforInstructorActiveStudent(instructorId) {
  //console.log("classId",classId,instructorId);
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    //.eq("classId", classId)
    .eq("studentisActive", true)
    .or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
    .order('studentName', { ascending: true });
  if (error) {
    throw new Error("Failed to fetch data");
  }
  return data;
}

export async function getDataWithClassforAdmin(classId, instructorId) {
  //console.log("classId",classId,instructorId);
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    .eq("classId", classId)
    .eq("instructorId", instructorId);
    //.or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`);
  if (error) {

    console.log("Error",error);
    
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getStudentClass(studentId) {
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    .eq("studentId", studentId);

  if (error) {
    throw new Error("Failed to fetch data");
  }
  console.log("error", error, data);
  return data;
}

export async function getIdData(id) {
  const { data, error } = await supabase
    .from("classdetailview")
    .select()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function addData(adata) {
  const { data, error } = await supabase
    .from("classdetailview")
    .insert(adata)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function updateData(udata) {
  const { data, error } = await supabase
    .from("classdetailview")
    .update(udata)
    .eq("id", udata.id)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function deleteIdData(id) {
  const { data, error } = await supabase
    .from("classdetailview")
    .delete()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function deleteFromData(ddata) {
  const { data, error } = await supabase
    .from("classdetailview")
    .delete()
    .eq("classId", ddata.classId)
    .or(
      `instructorId.eq.${ddata.instructorId},subinstructorId.eq.${ddata.instructorId}`
    )
    .eq("studentId", ddata.studentId);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}
